import axios from 'axios';
import { isObjectLike, isSafeInteger } from 'lodash';
import Logger from '@sm360/logger-sentry';

import config from 'financing/config/index.js';
import { ConfigsService as GeneralConfigsService, HTTPService } from '@sm360/widget-commons-core-services';
import { CookieService } from '@sm360/widget-commons-general';

/**
 * Service to interact with Financing
 */
class FinancingService {
    constructor() {
        this.basePath = `${config.endpoint.widget}/widgets/financing`;
        this.logger = new Logger('FinancingService', GeneralConfigsService.getLoggerContext());
    }

    _callSaveFinancing() {
        const trackedPageCookie = CookieService.getToken('primary-tracked-page');
        const adgearUidCookie = CookieService.getToken('aguid');
        const authTokenCookie = CookieService.getToken('auth-token');

        const trackedPage = {};
        if (trackedPageCookie) {
            try {
                trackedPage.primaryTrackedPage = JSON.parse(trackedPageCookie.replace(/\\/g, ''));
            } catch (e) {
                this.logger.error(`Failed to parse to JSON the following cookie "${trackedPageCookie}"`, e);
            }
        }

        if (adgearUidCookie) {
            trackedPage.adgearUid = adgearUidCookie;
        }

        if (authTokenCookie) {
            trackedPage.token = authTokenCookie;
        }

        return trackedPage;
    }

    /**
     * Will *create* a financing with the given information
     * @deprecated
     *
     * @param {any} financing The financing object to create
     * @param {any} leadId The id of the lead to update. Must be an integer
     * @returns {Promise} The result data in a promise
     * @memberof FinancingService
     */
    createFinancing(financing, leadId) {
        return new Promise((resolve, reject) => {
            if (!isObjectLike(financing) || !isSafeInteger(leadId)) {
                return reject(
                    HTTPService.formatRejectResponse('invalidParams', {
                        status: 400,
                    })
                );
            }

            const trackedPage = this._callSaveFinancing();

            return axios.post(this.basePath, {
                ...financing,
                ...trackedPage,
                leadId,
            });
        });
    }

    /**
     * Will save the financing information
     *
     * @param {any} financing The financing object to create
     * @returns {Promise} The result data in a promise
     * @memberof FinancingService
     */
    saveFinancing(financing, leadId, websiteId) {
        return new Promise((resolve, reject) => {
            if (!isObjectLike(financing)) {
                return reject(
                    HTTPService.formatRejectResponse('invalidParams', {
                        status: 400,
                    })
                );
            }

            const trackedPage = this._callSaveFinancing();

            return resolve(
                axios.put(this.basePath, {
                    ...financing,
                    ...trackedPage,
                    websiteId,
                    leadId,
                })
            );
        });
    }
}

export default new FinancingService();
